'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.device_index', {
    url: 'device_index',
    template: '<device-index></device-index>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/device_config/index/device_index.routes.js